//commons
export  const common = "https://nas.simyuan.com:8181/simonboard"
// export  const common = "http://localhost:8180/simonboard"

export default {
    common,
  }